export default __webpack_public_path__ + "static/0044-1866df2e8b8696159fa3729954a6cce0.png";